/* eslint react/jsx-props-no-spreading: 0 */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import PropTypes from "prop-types";
import React from "react";
import { useDispatch } from "react-redux";

import { isFileFolderName } from "../../../common/FileUtil";
import { fechCreateFolder } from "../../../store/FileStore";
import useStyles from "../useStyles";

/**
 * フォルダ作成ダイアログコンポーネント.
 *
 * @param {boolean} isOpenDialog ダイアログの表示状態
 * @param {function} onClose ダイアログクローズ時の処理
 * @param {string} filePrefix ファイルプレフィックス
 * @return {object} コンポーネント
 */
function CreateFolderDialog(props) {
  // 引数
  const {
    // ダイアログの表示状態（true：表示、false：非表示）
    isOpenDialog,
    // ダイアログクローズ時の処理
    onClose,
    // ファイルプレフィックス
    filePrefix,
  } = props;

  // スタイル
  const styles = useStyles();

  const [folderName, setFolderName] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");

  // Dispatch
  const dispatch = useDispatch();

  // ダイアログクローズ時の処理
  const handleDialogClose = () => {
    setErrorMessage("");
    setFolderName("");
    onClose();
  };

  // 作成押下時の処理
  const handleCreateButtonClick = () => {
    if (!folderName || folderName.trim() === "") {
      setErrorMessage("フォルダ名を入力してください。");
      return;
    }
    if (!isFileFolderName(folderName)) {
      setErrorMessage("フォルダ名に使用できない文字が入力されています。");
      return;
    }
    dispatch(fechCreateFolder(filePrefix, folderName.trim()));
    handleDialogClose();
  };

  const handleFolderNameChange = (event) => {
    if (event && event.target) {
      setFolderName(event.target.value);
    }
  };

  return (
    <Dialog
      open={isOpenDialog}
      fullWidth
      maxWidth="sm"
      onClose={handleDialogClose}
    >
      <DialogTitle>フォルダの作成</DialogTitle>
      <DialogContent className={styles.dialogContent}>
        <TextField
          error={Boolean(errorMessage)}
          className={styles.dialogTextFieldFolderName}
          label="フォルダ名"
          onChange={handleFolderNameChange}
          fullWidth
          helperText={errorMessage}
          inputProps={{ maxLength: 50 }}
        />
      </DialogContent>
      <DialogActions className={styles.dialogActions}>
        <Button color="default" onClick={handleDialogClose}>
          CANCEL
        </Button>
        <Button color="primary" onClick={handleCreateButtonClick}>
          CREATE
        </Button>
      </DialogActions>
    </Dialog>
  );
}

CreateFolderDialog.propTypes = {
  isOpenDialog: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  filePrefix: PropTypes.string.isRequired,
};

export default CreateFolderDialog;
